import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/anime';

export default function ArticleList() {
  const navigate = useNavigate();
  const latestArticles = articles.slice(0, 3);

  const handleClick = (id: string) => {
    navigate(`/article/${id}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            动漫资讯
          </h2>
          <p className="text-sm text-foreground-600 mt-2">最新动漫评测、推荐与文化解读</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <article
              key={article.id}
              className="bg-background-50 rounded-xl overflow-hidden cursor-pointer group hover:bg-background-50 transition-all border border-background-200/70"
              onClick={() => handleClick(article.id)}
            >
              <div className="aspect-video overflow-hidden bg-background-200">
                <img
                  src={article.cover}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="bg-accent-100 text-accent-700 px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                  <span>{article.date}</span>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/70">
                  <span className="text-xs text-foreground-500">{article.author}</span>
                  <div className="flex items-center gap-1 text-xs text-foreground-500">
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-eye-line"></i></span>
                    {(article.views / 10000).toFixed(1)}万
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}